<template>
  <!-- Success page-->
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-3">
          Siparişiniz Başarıyla Gerçekleşti 🎉🥳🎉
        </h2>
        <h4 class="mb-3">
          Kargo takip numarası tarafınıza e-posta ile ulaştırılacaktır.
        </h4>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          @click="openWindow"
        >
          Anasayfaya Dön
        </b-button>

      </div>
    </div>
  </div>
  <!-- / Success page-->
</template>

<script>
import { mapGetters } from 'vuex'
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
  computed: {
    ...mapGetters({
      basketList: 'eCommerce/getBasketList',
    }),
  },
  methods: {
    openWindow() {
      window.open('https://idycard.com', '_self')
    },
  },
}
</script>
